import { ReactNode, useMemo } from 'react'
import sanitize from 'sanitize-html'

import { Translation } from 'cng-common/features/translations/components/translation'
import { TPopupHorizontal } from 'core-components/library/popup'
import { Tooltip } from 'core-components/library/tooltip'

import { OVERALL_CATEGORY } from '../../../../config'

import styles from './RetailCategoryTitle.module.scss'

interface IProps {
  category: string
  subCategory: string
  l3Category?: string
  endContent?: ReactNode
  tip: string
  tipPrefix?: string
  isHideTooltip?: boolean
}

export const RetailCategoryTitle = ({
  category,
  subCategory,
  l3Category,
  endContent,
  tip,
  tipPrefix,
  isHideTooltip,
}: IProps) => {
  const uniqueCategory = useMemo(
    () => (!subCategory || subCategory === OVERALL_CATEGORY ? category : subCategory),
    [category, subCategory]
  )
  const uniqueL3Category = useMemo(
    () => (!l3Category || l3Category === OVERALL_CATEGORY ? subCategory : l3Category),
    [subCategory, l3Category]
  )
  const isShowL3Category = useMemo(
    () => !!l3Category && l3Category !== OVERALL_CATEGORY,
    [l3Category]
  )
  const uniqueCategoryTag = useMemo(
    () => (isShowL3Category ? uniqueL3Category : uniqueCategory),
    [isShowL3Category, uniqueL3Category, uniqueCategory]
  )
  const categoryTooltipKey = useMemo(() => {
    const categoryTipPrefix = !tipPrefix ? 'jbp-planning' : tipPrefix

    return `${categoryTipPrefix}-${uniqueCategoryTag}-tip`.replace(/\s/g, '').toLowerCase()
  }, [tipPrefix, uniqueCategoryTag])

  return (
    <div className={styles.root}>
      <Tooltip
        inline
        tipContent={() => (
          <div className={styles.productLineTip}>
            {tip ? (
              <span dangerouslySetInnerHTML={{ __html: sanitize(tip) }} />
            ) : (
              <Translation htmlAvailable text={categoryTooltipKey} span actionsInside />
            )}
          </div>
        )}
        horizontalStartPosition={TPopupHorizontal.Right}
        horizontalDirection={TPopupHorizontal.Right}
        disabled={!!isHideTooltip}
      >
        <div className={styles.productLine}>
          {!isShowL3Category && <Translation text={subCategory || category} span actionsInside />}
          {isShowL3Category && <Translation text={l3Category || ''} span actionsInside />}
        </div>
      </Tooltip>
      {endContent}
    </div>
  )
}
